import moment from 'moment';

export const formatDate = (date) => {
    if (!date) return '';
    return moment.utc(date).format('MMM D, YYYY');
}

export const formatDateTime = (date) => {
    if (!date) return '';
    return moment.utc(date).local().format('MMM D, YYYY, HH:mm');
}

export const isDateExpired = dateToCheck => {
    const date = new Date(dateToCheck);
    const currentDate = new Date();

    return date < currentDate;
};
